import type { ReactNode } from 'react';

import STYLES from './MainContent.module.scss';

type Props = { children: ReactNode | ReactNode[] };

type SectionProps = {
  id?: string;
  className?: string;
} & Props;

const MainContent = ({ children }: Props) => (
  <div className={STYLES.MainContent}>{children}</div>
);

const ContentSection = ({ children, className, id }: SectionProps) => {
  const classNames = [STYLES.MainContent__section];

  if (className) {
    classNames.push(className);
  }

  return (
    <div id={id} className={classNames.join(' ')}>
      {children}
    </div>
  );
};

export default MainContent;
export { ContentSection };
